import React, { Fragment } from "react";
import { ROUTES } from "../../../../routes";
import Link from "../../../elements/link";
import { getCategoryUrl } from "../../../../helpers/product";
function Footer(): React.JSX.Element {
  const appName = process.env.APP_NAME;
  const appDomain = process.env.APP_DOMAIN;
  const businessAddressLine1 = process.env.BUSINESS_ADDRESS_LINE1;
  const businessAddressLine2 = process.env.BUSINESS_ADDRESS_LINE2;
  const businessAddressLine3 = process.env.BUSINESS_ADDRESS_LINE3;
  const supportPhoneNumber = process.env.SUPPORT_PHONE_NUMBER;

  const facebookUrl  = process.env.FACEBOOK_URL;
  const linkedinUrl  = process.env.LINKEDIN_URL;
  const instagramUrl = process.env.INSTAGRAM_URL;
  const twitterUrl   = process.env.TWITTER_URL;
  const youtubeUrl   = process.env.YOUTUBE_URL;
  const vendorBackendUrl = process.env.VENDOR_BACKEND_URL;

  const currYear = new Date().getFullYear();

  return (
    <div className="footer">
      {/* Begin Footer Static Middle Area */}
      <div className="footer-static-middle">
        <div className="container">
          <div className="footer-logo-wrap pt-50 pb-35">
            <div className="row">
              {/* Begin Footer Logo Area */}
              <div className="col-lg-4 col-md-6">
                <div className="footer-logo">
                  <Link to={ROUTES.HOME}>
                    {/*<img src="/images/menu/logo/footer-logo.png" alt="Footer Logo" />*/}
                    <img src="/images/branding/SecondaryLogo.svg" alt={`${appName} Footer Logo`} />
                  </Link>
                  <p className="info text-muted">Customer support:</p>
                </div>
                <ul className="des">
                  <li className="support-phone"><a href="#">{supportPhoneNumber}</a></li>
                  <li className="business-address">
                    {businessAddressLine1}
                    { businessAddressLine2 &&
                      <><br />{businessAddressLine2}</>
                    }
                    { businessAddressLine3 &&
                      <><br />{businessAddressLine3}</>
                    }
                  </li>
                  <li className="support-email">
                    <a href={`mailto://info@${appDomain}`}>
                      {`info@${appDomain}`}
                    </a>
                  </li>
                </ul>
              </div>
              {/* Footer Logo Area End Here */}

              {/* Begin Footer Block Area */}
              <div className="col-lg-2 col-md-3 col-sm-6">
                <div className="footer-block">
                  <h3 className="footer-block-title">Top Categories</h3>
                  <ul>
                    <li>
                      <Link to={generateCategoryUrl("Computers & Accessories")}>
                        Computers & Laptops
                      </Link>
                    </li>
                    <li>
                      <Link to={generateCategoryUrl("Phones & Tablets")}>
                        Smart phones
                      </Link>
                    </li>
                    <li>
                      <Link to={generateCategoryUrl("Headphones")}>
                        Headphones
                      </Link>
                    </li>
                    <li className="with-streak">
                      <span></span>
                      <Link to={generateCategoryUrl("Appliances")}>
                        Appliances
                      </Link>
                    </li>
                    <li>
                      <Link to={generateCategoryUrl("Cameras & Photos")}>
                        Cameras & photos
                      </Link>
                    </li>
                    <li>
                      <Link to={generateCategoryUrl("Electronics")}>
                        TV & Homes
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              {/* Footer Block Area End Here */}

              {/* Begin Footer Block Area */}
              <div className="col-lg-2 col-md-3 col-sm-6">
                <div className="footer-block">
                  <h3 className="footer-block-title">Quick Links</h3>
                  <ul>
                    <li>
                      <Link to={ROUTES.SHOP}>
                        Shop products
                      </Link>
                    </li>
                    <li>
                      <Link to={ROUTES.CART}>
                        Shopping cart
                      </Link>
                    </li>
                    <li>
                      <Link to={ROUTES.WISHLIST}>
                        Wishlist
                      </Link>
                    </li>
                    <li>
                      <Link to={ROUTES.PRODUCT_COMPARE.replace(":productId", "all")}>
                        Compare products
                      </Link>
                    </li>
                    <li>
                      <Link to={ROUTES.ORDER_TRACKING.replace(":orderReferenceNumber", "all")}>
                        Track orders
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              {/* Footer Block Area End Here */}

              {/* Begin Footer Block Area */}
              <div className="col-lg-4">
                <div className="footer-block">
                  <h3 className="footer-block-title">Our company</h3>
                  <ul>
                    <li>
                      <Link to={ROUTES.ABOUT_US}>
                        About us
                      </Link>
                    </li>
                    <li>
                      <Link to={ROUTES.PRIVACY_POLICY}>
                        Privacy Policy
                      </Link>
                    </li>
                    <li>
                      <Link to={ROUTES.CONTACT_US}>
                        Contact us
                      </Link>
                    </li>
                  </ul>

                  <h3 className="footer-block-title">Follow Us</h3>
                  <ul className="social-link">
                    <li className="twitter">
                      <a href={twitterUrl} data-toggle="tooltip" target="_blank" title="Twitter">
                        <i className="fa fa-x" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li className="facebook">
                      <a href={facebookUrl} data-toggle="tooltip" target="_blank" title="Facebook">
                        <i className="fa fa-facebook" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li className="instagram">
                      <a href={instagramUrl} data-toggle="tooltip" target="_blank" title="Instagram">
                        <i className="fa fa-instagram" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li className="linkedin">
                      <a href={linkedinUrl} data-toggle="tooltip" target="_blank" title="LinkedIn">
                        <i className="fa fa-linkedin" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li className="youtube">
                      <a href={youtubeUrl} data-toggle="tooltip" target="_blank" title="YouTube">
                        <i className="fa fa-youtube" aria-hidden="true"></i>
                      </a>
                    </li>
                  </ul>
                </div>

              </div>
              {/* Footer Block Area End Here */}
            </div>
          </div>
        </div>
      </div>
      {/* Footer Static Middle Area End Here */}

      <div className="row">
        <div className="col-lg-12">
          <div className="text-center">
            { vendorBackendUrl && ( 
              <Fragment>
                <span style={{ marginRight: "5px", color: "#fff" }}>
                  Reach more customers: 
                </span>
                <a href={vendorBackendUrl} target="_blank" rel="noopener noreferrer"> 
                  <i className="fa fa-store" aria-hidden="true" style={{ marginRight: "5px" }}></i>
                  <span>Become a vendor</span>
                  <i className="fa fa-external-link" aria-hidden="true" style={{ marginLeft: "5px", position: "relative", top: "1px" }}></i>
                </a>
              </Fragment>
            )}
          </div>
        </div>
      </div>


      <hr className="footer-separator" />

        {/* Begin Footer Static Bottom Area */}
        <div className="footer-static-bottom pt-0 pb-20">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        {/* Begin Footer Links Area */}
                        {/*<div className="footer-links" style={{ display: "none" }}>
                            <ul>
                                <li><a href="#">Online Shopping</a></li>
                                <li><a href="#">Promotions</a></li>
                                <li><a href="#">My Orders</a></li>
                                <li><a href="#">Help</a></li>
                                <li><a href="#">Customer Service</a></li>
                                <li><a href="#">Support</a></li>
                                <li><a href="#">Most Populars</a></li>
                                <li><a href="#">New Arrivals</a></li>
                                <li><a href="#">Special Products</a></li>
                                <li><a href="#">Manufacturers</a></li>
                                <li><a href="#">Our Stores</a></li>
                                <li><a href="#">Shipping</a></li>
                                <li><a href="#">Payments</a></li>
                                <li><a href="#">Warantee</a></li>
                                <li><a href="#">Refunds</a></li>
                                <li><a href="#">Checkout</a></li>
                                <li><a href="#">Discount</a></li>
                                <li><a href="#">Refunds</a></li>
                                <li><a href="#">Policy Shipping</a></li>
                            </ul>
                        </div>*/}
                        {/* Footer Links Area End Here */}
                        {/* Begin Copyright Area */}
                        <div className="copyright text-center pt-5 pb-10">
                          <span>
                            <a href="#" onClick={(e) => e.preventDefault()}>
                              &copy; {currYear <= 2025 ? 2025 : `2025 - ${currYear}`} {appName?.toLowerCase()}
                            </a>
                          </span>
                        </div>
                        {/* Copyright Area End Here */}
                    </div>
                </div>
            </div>
        </div>
        {/* Footer Static Bottom Area End Here */}
    </div>
  );
}

export default Footer;

function generateCategoryUrl(categoryName: string): string {
  return getCategoryUrl({ name: categoryName.toLowerCase() });
}

